import { ModalContent, Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import styled from 'styled-components';

interface Props {
	className?: string;
	onClose: () => void;
}

const PEPModal = ({ onClose, className }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<Modal className={className} onClose={onClose} size="md">
			<SectionHeader title={tCommonUi(`PEPModal.title`)} />
			<Text variant="button">{tCommonUi(`PEPModal.section1`)}</Text>
			<br />
			<br />
			<Text variant="button">{tCommonUi(`PEPModal.section2`)}</Text>
			<br />
			<br />
			<ol>
				{[
					tCommonUi(`PEPModal.a`),
					tCommonUi(`PEPModal.b`),
					tCommonUi(`PEPModal.c`),
					tCommonUi(`PEPModal.d`),
					tCommonUi(`PEPModal.e`),
					tCommonUi(`PEPModal.f`),
					tCommonUi(`PEPModal.g`),
					tCommonUi(`PEPModal.h`),
				].map((text) => {
					return (
						<li key={text}>
							<Text variant="button">{text}</Text>
						</li>
					);
				})}
			</ol>
		</Modal>
	);
};

const Styled = styled(PEPModal)`
	${ModalContent} {
		margin-bottom: 4em;
	}

	${SectionHeader} {
		margin-bottom: 0.5em;
	}

	ol {
		list-style: lower-alpha;
		padding-left: 3em;

		${Text} {
			display: block;
		}

		li {
			padding-left: 0.3em;
			margin-bottom: 0.3em;
		}
	}
`;

export { Styled as PEPModal };
